// My account: password and 2-step. Turning 2-step on refreshes the screens only after the recovery codes are
// saved (useRefreshAll), so the codes stay on screen even when that answer finishes a sign-in.
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'
import type { ChangePasswordInput, CodeInput, PasswordInput } from '@/api/schemas'
import { useChange } from '@/api/useChange'

export const useChangePassword = () =>
  useChange((api, input: ChangePasswordInput) => api.changePassword(input))

/** a new key for the authenticator app; asked once when the set-up opens */
export function useTwoStepKey() {
  const api = useApi()
  return useMutation({ mutationFn: () => api.setUpTwoStep() })
}

/** confirms the key with a code; the answer carries the recovery codes */
export function useConfirmTwoStep() {
  const api = useApi()
  return useMutation({ mutationFn: (input: CodeInput) => api.confirmTwoStep(input) })
}

/** new recovery codes; the screens need no refresh (nothing else changes) */
export function useRenewRecoveryCodes() {
  const api = useApi()
  return useMutation({ mutationFn: (input: CodeInput) => api.renewRecoveryCodes(input) })
}

export const useDisableTwoStep = () => useChange((api, input: PasswordInput) => api.disableTwoStep(input))

/** every screen reads the API again (after the recovery codes are saved) */
export function useRefreshAll() {
  const queryClient = useQueryClient()
  return () => void queryClient.invalidateQueries()
}
